import { Focus, Sport, SportType } from "../models/user.models";

export const getSportMappings = () => {
    const appContext = window.localStorage.getItem('app_context');
    return appContext ? JSON.parse(appContext)?.sport_configuration ?? [] : [];
};

export const getSportsOptionsFromMapping = (mappings: any[]) => {
    return mappings.map((sport: Sport) => (sport.name))
}

export const getSportsTypeOptionsFromMapping = (mappings: any[], selectedSport: string) => {
    return mappings.find((sport: Sport) => sport.name === selectedSport)?.sport_types?.map((sportType: SportType) => (sportType.name))
}

export const getFocusOptionsFromMapping = (mappings: any[], selectedSport: string) => {
    return mappings.find((sport: Sport) => sport.name === selectedSport)?.focuses?.map((focus: Focus) => (focus.name))
}